import React, { createContext, FC, useContext } from 'react';
import { Vector } from '@glueapp/graph-types';

export const NodePositionContext = createContext<Vector>({ x: 0, y: 0 });

interface NodePositionContextProviderProps {
    nodePosition: Vector;
    children: React.ReactNode;
}

export const NodePositionContextProvider: FC<NodePositionContextProviderProps> = props => {
    return <NodePositionContext.Provider value={props.nodePosition}>{props.children}</NodePositionContext.Provider>;
};

export function useNodePosition(): Vector {
    return useContext(NodePositionContext);
}
